export const SubAccountsTypes = {
  SHOW_SUB_ACCOUNTS: "SHOW_SUB_ACCOUNTS",
  ADD_SUB_ACCOUNTS: "ADD_SUB_ACCOUNTS",
  DELETE_SUB_ACCOUNTS: "DELETE_SUB_ACCOUNTS",
  UPDATE_SUB_ACCOUNTS: "UPDATE_SUB_ACCOUNTS",
};
